
import { Component, Vue } from 'vue-property-decorator';
import { createAdmin, getAuth, isAuthEmpty } from "@/axios/axios.auth";
import SimpleForm from "@/components/shared/SimpleForm.vue";
import {getDbId, setDbId} from "@/shared/local.storage.utils";

@Component({
  components: {SimpleForm}
})
export default class AdminLogin extends Vue {
  // Les props
  // Les propriétés
  private dbname: string = ''
  private email: string = ''
  private password: string = ''
  private disableLoginBtn: boolean = false
  private disableEmail: boolean = false
  private isLoading: boolean = false
  private errMsg: string = ''
  private showAmorceDialog: boolean = false
  private adminPass: string = ''

  // Les propriétés calculées
  private get theme() {
    return this.$store.state.theme
  }
  // Les hooks
  public mounted() {
    this.dbname = getDbId()
  }
  // Les méthodes surveillées
  // Les méthodes d'instance
  private async onSubmit() {
    setDbId(this.dbname)
    this.errMsg = ''
    if (this.email === 'amorce' && this.password === 'amorce') {
      isAuthEmpty().then((estVide: boolean) => {
        if (estVide) {
          this.showAmorceDialog = true
        } else {
          this.errMsg = 'Amorçage impossible sur une base non vide'
        }
      })
    } else {
      this.isLoading = true
      const isAuth = await getAuth(this.email, this.password, true)
      this.isLoading = false
      if (isAuth === true) {
        this.$router.push({path: '/'}).then()
      } else {
        this.errMsg = isAuth as string
      }
    }
  }

  private async onCreateAdmin() {
    this.isLoading = true
    // console.log('onCreateAdmin adminPass', this.adminPass)
    const isCreated = await createAdmin(this.adminPass)
    if (isCreated) {
      this.email = 'admin'
      this.password = ''
    } else {
      this.errMsg = 'Failed to create admin account'
    }
    this.isLoading = false
  }

  private async quit() {
    // await this.$store.dispatch('auth/resetAuth')
    // this.$store.commit('current/resetCurrent')
    this.email = ''
    this.password = ''
    this.disableEmail = false
    this.disableLoginBtn = false
  }
  // Les méthodes statiques
}
